<template>
    <div>
        <v-autocomplete :search-input.sync="search" :loading="isUpdating" :readonly="isUpdating" :items="searchItems"
            label="Team toevoegen" return-object item-text="name" v-model="searchItem" solo rounded auto-select-first
            no-filter @change="addItem" hide-details :item-disabled="itemDisabled" class="mb-4">
            <template v-slot:item="{ item }">
                <v-list-item-content>
                    <v-list-item-title v-text="item.name"></v-list-item-title>
                </v-list-item-content>
            </template>
        </v-autocomplete>
        <v-card>
            <v-card-text>
                <div v-if="value && value.length > 0">
                    <v-list>
                        <v-list-item v-for="item in value" :key="item.id">
                            <v-list-item-content>
                                <v-list-item-title v-text="item.name"></v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-icon>
                                <eod-actions-column :item="item" :deleteAction="deleteItem"
                                    :showEdit="false"></eod-actions-column>
                            </v-list-item-icon>
                        </v-list-item>
                    </v-list>
                </div>
                <v-list v-else>
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title>Er zijn nog geen teams gekoppeld.</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import eodColumnActions from './columns/eod-column-actions.vue';

export default {
    name: 'Groups',
    props: {
        value: Array,
        roles: Array
    },
    components: {
        'eod-actions-column': eodColumnActions,
    },
    data() {
        return {
            search: '',
            isUpdating: false,
            searchResults: [],
            searchItem: null,
            timeout: null,
        }
    },
    computed: {
        searchItems() {
            let arr_items = this.searchResults;
            return arr_items;
        },
    },
    methods: {
        itemDisabled(item) {
            if (this.value) {
                for (let j = 0; j < this.value.length; j++) {
                    if (item.id == this.value[j].id) {
                        return true;
                    }
                }
            }
            return false;
        },
        deleteItem(item) {
            let val = this.value;
            for (let i = 0; i < val.length; i++) {
                if (val[i].id == item.id) {
                    val.splice(i, 1);
                    this.$emit('input', val);
                    return;
                }
            }
        },
        addItem(item) {
            let val = this.value;

            if (!val) {
                val = [];
            }

            val.push(item);

            this.$emit('input', val);

            this.$nextTick(() => {
                this.searchResults = [];
                this.search = '';
                this.searchItem = null;
            });
        }
    },
    watch: {
        search(val) {
            // Items have already been requested
            if (this.timeout) {
                clearInterval(this.timeout);
            }

            this.timeout = setTimeout(() => {
                if (this.isUpdating) return;

                if (!val || val == '' || val.length < 2) {
                    this.searchResults = [];
                    return;
                };

                this.isUpdating = true;

                let variables = {
                    where: [
                        {
                            chain: 'and',
                            operator: 'ILIKE',
                            value: '%' + val + '%',
                            column: 'name'
                        }
                    ],
                }

                // Filter users
                this.$eod.get('groups', ['id', 'name', 'users{id}'], variables)
                    .then(result => {
                        this.searchResults = result.data.data.groups.edges;
                        this.isUpdating = false;
                        this.$forceUpdate();
                    });

                this.timeout = null;
            }, 500);

        },
    },
}
</script>